const FORM_ERROR_MESSAGES = {
  MANDATORY: "Please fill the mandatory fields",
  INVALID_NAME: "Please enter a valid name.",
  INVALID_EMAIL: "Please enter a email",
  INVALID_PHONE: "Please enter a valid mobile number",
  INVALID_PRODUCT_CODE: "Please enter valid product code",
  INVALID_POINT_OF_PURCHASE: "Please select a point of purchase",
  INVALID_DATE_OF_PURCHASE: "Please select date of purchase",
  SUCCESS: "Thank you! You’ll shortly receive an e-mail confirmation.",
  ERROR: "Oops! Something went wrong. Please try again",
  INVALID_PRODUCT_CATEGORY: "Please select a product category",
};

const WARRANTY_EXTENSION_DETAILS_LIST = {
  lists: [
    {
      subpoints: [
        " You must be a member of&nbsp;<a href='/circle' class='wc-warranty-terms-list'>The Circle</a>&nbsp;to be eligible for Warranty Extension.",
        "As a part of&nbsp;<a href='/circle' class='wc-warranty-terms-list'>The Circle</a>&nbsp;program, you’re entitled to a 12 month Warranty Extension* on your Wildcraft product belonging to Gear and Luggage categories, subject to the following conditions",
        " Warranty Extension valid only on Gear and Luggage categories.",
        " Your product must be under existing warranty tenure as per the warranty card or the invoice to be eligible for Warranty Extension.",
        "The 13 digit Product EAN code submitted must be a valid one.",
        "All other decisions in this regard rest with Wildcraft India Pvt. Ltd.",
      ],
    },
  ],
};

const WARRANTY_EXTENSION_DETAILS_CONCLUSION = " * Terms & Conditions apply.";
const THANK_YOU_MSG =
  "Thank you! You’ll shortly receive an e-mail confirmation.";
const TERMS_AND_CONDITIONS_TITLE = "Terms and conditions";
const FORM_TITLE1 = "Your exclusive circle membership privilege";
const FORM_TITLE = "Warranty extension";
const FILL_FORM_MSG = "Please fill in the required details below";
const FORM_BUTTON_TEXT = "SUBMIT";
const OTP_HEADING = "Verify OTP";
const SAME_MOBILE_NUMBER_TEXT =
  "The same mobile number used for circle registration to be used.";

const EMAIL = {
  templateId: "wildcraft_circle_warranty",
  from: "thecircle@wildcraft.com",
  subject: "Warranty Extended! | The Circle | Wildcraft",
};

const SMS = {
  templateId: "wildcraft_circle_warranty_sms",
};

const WARRANTY_EXTENSION_COMPONENT = {
  FORM_ERROR_MESSAGES,
  FORM_NAME: "WARRANTY_EXTENSION",
  WARRANTY_EXTENSION_DETAILS_LIST,
  WARRANTY_EXTENSION_DETAILS_CONCLUSION,
  THANK_YOU_MSG,
  TERMS_AND_CONDITIONS_TITLE,
  FORM_TITLE,
  FILL_FORM_MSG,
  FORM_BUTTON_TEXT,
  OTP_HEADING,
  SAME_MOBILE_NUMBER_TEXT,
  EMAIL,
  SMS,
  FORM_TITLE1,
};
export default WARRANTY_EXTENSION_COMPONENT;
